import { VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import { __, _x } from '@wordpress/i18n';
import { useSettings } from '@wordpress/block-editor';
import {VayuBlocksSelectControl} from '@vayu-blocks';

// "aspectRatio":{
//     "type":"object",
//     "default":{
//         "Desktop":"",
//         "Tablet":"",
//         "Mobile":""
//     }
// }
// }

export const VayuBlocksAspectRatio = ({
    aspectRatio,
    onChange,
    label = 'Aspect Ratio',
    options
}) => {

    const [ defaultRatios, themeRatios, showDefaultRatios ] = useSettings(
		'dimensions.aspectRatios.default',
		'dimensions.aspectRatios.theme',
		'dimensions.defaultAspectRatios'
	);

    const themeOptions = themeRatios?.map( ( { name, ratio } ) => ( {
		label: name,
		value: ratio,
	} ) );

	const defaultOptions = defaultRatios?.map( ( { name, ratio } ) => ( {
		label: name,
		value: ratio,
	} ) );

	const aspectRatioOptions = [
		{
			label: _x(
				'Original',
				'Aspect ratio option for dimensions control'
			),
			value: 'auto',
		},
		...( showDefaultRatios ? defaultOptions : [] ),
		...( themeOptions ? themeOptions : [] ),
		{
			label: _x( 'Custom', 'Aspect ratio option for dimensions control' ),
			value: 'custom',
			disabled: true,
			hidden: true,
		},
	];

    return (
        
        <VayuBlocksSelectControl
            label={<VayuBlocksDeviceControl label={__(label, 'vayu-blocks')} />}
            value={aspectRatio}
            options={options ?? aspectRatioOptions}
            onChange={onChange}
            responsive={true} 
        />
    );
};
